import React, { useEffect } from 'react'
import { Form, Modal, Row } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import { cloneChildComponents } from '../../../utils/helpers'

// Handles the view of M365 DISABLE_USER
function BlockSignIn(props) {
  const { children, ...rest } = props // eslint-disable-line react/prop-types
  const { intl, setDisableSubmit, disableSubmit, setCompletedActions } = rest

  const BLOCK_SIGN_IN_ACTION_ID = 'ENGAGE.BLOCK_SIGN_IN_SUCCESS'

  // Handles setting the completed action
  useEffect(() => {
    setCompletedActions((alreadyCompletedActions) => [...alreadyCompletedActions, BLOCK_SIGN_IN_ACTION_ID])
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Form>
      <Modal.Body>
        <Row>
          <div className="col-sm-12 col-md-12 col-lg-12">
            <p>
              <FormattedMessage id="ENGAGE.BLOCK_SIGNIN_DESC" />
            </p>
            <p>
              <FormattedMessage id="ENGAGE.BLOCK_SIGNIN_DESC_2" />
            </p>
            <div>
              <Form.Group id="formGridCheckbox">
                <Form.Check
                  custom
                  type="checkbox"
                  id="confirmBlock"
                  checked={disableSubmit === false}
                  defaultChecked={disableSubmit === false}
                  label={
                    intl
                      ? intl.formatMessage({
                          id: 'ENGAGE.BLOCK_USER_FROM_SIGNING_IN',
                        })
                      : ''
                  }
                  onClick={() => {
                    setDisableSubmit(disableSubmit === false)
                  }}
                />
              </Form.Group>
            </div>
          </div>
        </Row>
      </Modal.Body>

      {/* Footer Child */}
      {cloneChildComponents({ ...rest }, children)}
    </Form>
  )
}

export default BlockSignIn
